/**
 * Constants and type definitions for Spray Calculator
 * All string values are keys for i18n translation
 */

// Calculator steps
export const STEPS = {
  SPRAYER: 1,
  AREA: 2,
  TREATMENT: 3,
};

export const STEP_KEYS = {
  1: 'SPRAYER',
  2: 'AREA',
  3: 'TREATMENT',
};

export const TOTAL_STEPS = 3;

// Step configuration for wizard
export const STEP_CONFIG = [
  {
    key: STEPS.SPRAYER,
    titleKey: 'step_1_title',
    numberKey: 'step_1_number',
  },
  {
    key: STEPS.AREA,
    titleKey: 'step_2_title',
    numberKey: 'step_2_number',
  },
  {
    key: STEPS.TREATMENT,
    titleKey: 'step_3_title',
    numberKey: 'step_3_number',
  },
];

// Application types
export const APPLICATION_TYPES = {
  FULL_SURFACE: 'full_surface',
  BAND: 'band',
};

// Colors from Figma design
export const COLORS = {
  PRIMARY_GREEN_DARK: '#083D26',
  PRIMARY_GREEN: '#105235',
  PRIMARY_GREEN_LIGHT: '#207D54',
  ACCENT_LIME: '#A0D911',
  ACCENT_YELLOW: '#FFD666',
  BACKGROUND_LIGHT: '#F5F5F5',
  BACKGROUND_WHITE: '#FFFFFF',
  TEXT_PRIMARY: '#141414',
  TEXT_SECONDARY: '#8C8C8C',
};

// API endpoints
export const API_ENDPOINTS = {
  LIQUID_VOLUME_UNITS: '/api/sprays/liquid-volume-units/',
  AREAS: '/api/sprays/areas/',
  MEASUREMENT_UNITS: '/api/sprays/measurement-units/',
  WATER_VOLUME_PER_AREAS: '/api/sprays/water-volume-per-areas/',
  PRODUCT_DOSES: '/api/sprays/product-doses/',
  COMMERCIAL_PRODUCTS: '/api/commercial-products/',
  CALCULATE: '/api/sprays/calculate/',
};
